import React, { useState } from 'react';
import { Grid2X2, ScanLine, Maximize2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { standardLeads } from '@/data/ekg';
import { EcgTrace } from './EcgTrace';
import { EcgDetailDialog } from './EcgDetailDialog';

export const EcgViewer = ({ pattern }) => {
  const [mode, setMode] = useState('focus');
  const [annotated, setAnnotated] = useState(true);
  const [detailLead, setDetailLead] = useState(null);
  const leads = mode === 'overview' && !pattern.rhythmOnly
    ? standardLeads.map(lead => ({ lead, note: pattern.focus.find(item => item.lead === lead)?.note })) : pattern.focus;
  const isOverview = mode === 'overview' && !pattern.rhythmOnly;

  return (
    <section className="min-w-0" aria-label="EKG-Lehrkurven">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="ekg-view-switch" role="group" aria-label="Kurvenansicht">
          <button onClick={() => setMode('focus')} aria-pressed={!isOverview} data-testid="ekg-view-focus"><ScanLine size={16} />Fokus</button>
          {!pattern.rhythmOnly && <button onClick={() => setMode('overview')} aria-pressed={isOverview} data-testid="ekg-view-overview"><Grid2X2 size={16} />12 Ableitungen</button>}
        </div>
        <label className="flex items-center gap-2 text-xs cursor-pointer" htmlFor="ekg-markings">
          <Checkbox id="ekg-markings" checked={annotated} onCheckedChange={setAnnotated} data-testid="ekg-markings-checkbox" />Markierungen
        </label>
      </div>
      <div className={isOverview ? 'ekg-lead-grid' : 'space-y-4'} data-testid="ekg-waveform-panel">
        {leads.map(({ lead, note }) => <div className={`ekg-lead ${pattern.focus.some(item => item.lead === lead) ? 'is-focus-lead' : ''}`} key={lead}>
          <div className="ekg-lead-heading">
            <span className="font-semibold text-sm" data-testid={`ekg-lead-label-${lead}`}>{lead}</span>
            {!isOverview && <span className="text-xs text-muted-foreground flex-1" data-testid={`ekg-lead-note-${lead}`}>{note}</span>}
            <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0" aria-label={`Ableitung ${lead} vergrößern`} title={`Ableitung ${lead} vergrößern`} onClick={() => setDetailLead(lead)} data-testid={`ekg-enlarge-${lead}`}><Maximize2 size={15} /></Button>
          </div>
          <EcgTrace pattern={pattern} lead={lead} duration={isOverview ? 2.5 : pattern.duration} annotated={annotated && !isOverview} testId={`ekg-trace-${lead}`} />
        </div>)}
      </div>
      {isOverview && pattern.id === 'st-posterior' && <div className="mt-4" data-testid="ekg-posterior-extra-leads">
        <h3 className="text-sm font-semibold mb-3">Posteriore Zusatzableitungen · nicht Teil der 12 Standardableitungen</h3>
        <div className="ekg-extra-leads">{['V7', 'V8', 'V9'].map(lead => <div className="ekg-lead is-focus-lead" key={lead}>
          <div className="ekg-lead-heading"><span className="text-sm font-semibold">{lead}</span><Button variant="ghost" size="icon" className="h-8 w-8" data-testid={`ekg-enlarge-${lead}`} aria-label={`Ableitung ${lead} vergrößern`} onClick={() => setDetailLead(lead)}><Maximize2 size={15} /></Button></div>
          <EcgTrace pattern={pattern} lead={lead} duration={2.5} annotated={false} testId={`ekg-trace-${lead}`} />
        </div>)}</div>
      </div>}
      <p className="ekg-chart-caption" data-testid="ekg-chart-disclaimer">
        {isOverview ? 'Schematische Ableitungsskizzen, keine zusammenhängende 12-Kanal-Aufzeichnung. ' : 'Schematische Lehrkurven, keine Patientenaufzeichnung. '}
        Großes Rasterfeld: 0,2 s / 0,5 mV. Anzeige skaliert.
      </p>
      {detailLead && <EcgDetailDialog pattern={pattern} lead={detailLead} annotated={annotated} onClose={() => setDetailLead(null)} />}
    </section>
  );
};